<template>
  <b-nav-item-dropdown
    class="dropdown-notification mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        :badge="unreaded"
        badge-classes="bg-danger"
        class="text-body"
        icon="BellIcon"
        size="21"
        
      />
      <!-- @click="ReadNotifications()" -->
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          {{ $t("site.notifications") }}
        </h4>
        <b-badge pill variant="light-primary">
          {{ unreaded }}
        </b-badge>
      </div>
    </li>

    <!-- Notifications -->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <!-- Account Notification -->
      <!-- <b-link
        v-for="notification in notifications"
        :key="notification.subtitle"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="32"
              :src="notification.avatar"
              :text="notification.avatar"
              :variant="notification.type"
            />
          </template>
          <p class="media-heading">
            <span class="font-weight-bolder">
              {{ notification.title }}
            </span>
          </p>
          <small class="notification-text">{{ notification.subtitle }}</small>
        </b-media>
      </b-link> -->

      <!-- System Notifications -->
      <b-link
        v-for="notification in systemNotifications"
        :key="notification.id"
        @click="saveActivityType(notification)"

      >
        <b-media >
          <template #aside v-if="notification.read_at!=null" >
            <b-avatar size="32" variant="light-success">
              <feather-icon icon="CheckIcon" />
            </b-avatar>
          </template>
          <p class="media-heading" v-if="notification.data.type=='activity'">
            <span class="font-weight-bolder" >
              {{ $t("notifications.new_activity_added")+':'+ JSON.parse(notification.data.name).name+' '+$t('notifications.in_course')+':'+JSON.parse(notification.data.name).course_name  }}
            </span>
          </p>
          <p class="media-heading" v-else-if="notification.data.type=='correct_activity'">
            <span class="font-weight-bolder" >
              {{$t("notifications.activity_corrected")+':'+ JSON.parse(notification.data.name).activity.name+' '+$t('notifications.in_course')+':'+JSON.parse(notification.data.name).course_name+' '+$t("notifications.your_grade")+':'}}
              <b-avatar size="32" variant="light-success">
                {{JSON.parse(notification.data.name).grade+'/'+JSON.parse(notification.data.name).activity.grade}}
              </b-avatar>
            </span>
          </p>
          <p class="media-heading" v-else-if="notification.data.type=='activity_answer'">
            <span class="font-weight-bolder" >
              {{$t("notifications.student_answered")+':'+  JSON.parse(notification.data.name).student.full_name+' '+$t("notifications.on_activity")+':'+ JSON.parse(notification.data.name).activity.name+' '+$t('notifications.in_course')+':'+JSON.parse(notification.data.name).course_name  }}
            </span>
          </p>
          <p class="media-heading" v-else-if="notification.data.type=='room'">
            <span class="font-weight-bolder" >
              {{$t("notifications.you_are_add_to")+':'+  JSON.parse(notification.data.name).room_name+' '+$t("notifications.on_program")+':'+ JSON.parse(notification.data.name).program_name  }}
            </span>
          </p>
          <p class="media-heading" v-else-if="notification.data.type=='master'">
            <div v-if="notification.data.name.type == 'student'">
              <span class="font-weight-bolder" v-if="notification.data.name.value == 1" >
                تم الموافقة علي مرحلة {{ $t("master."+notification.data.name.key) }} في  {{ notification.data.name.title  }}
              </span>
              <span class="font-weight-bolder" v-else-if="notification.data.name.value == 0" >
                تم رفض مرحلة {{ $t("master."+notification.data.name.key) }} في  {{ notification.data.name.title  }}
              </span>
              <span class="font-weight-bolder" v-else-if="notification.data.name.value == 2" >
                تم تحديد {{ notification.data.name.starts_in }} كمعاد للندوة في  {{ notification.data.name.title  }}
              </span>
            </div>
            <div v-else-if="notification.data.name.type == 'teacher'">
              <span class="font-weight-bolder" >
                تم رفع ملف في {{ notification.data.name.title   }} للمرحلة {{ $t("master."+notification.data.name.key) }}
              </span>
            </div>
          </p>
          <!-- <p class="media-heading" v-else>
            <span class="font-weight-bolder">
              مستخدم جديد
            </span>
          </p> -->
          <!-- <row> -->
            <b-col lg="6">
                <small class="notification-text">{{$t(notification.data.message)}}</small>
            </b-col>
            <b-col lg="6">
            <small class="notification-text">{{moment(notification.created_at).fromNow()}}</small>
            </b-col>
          <!-- </row> -->
        </b-media>
      </b-link>
      
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li class="dropdown-menu-footer">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
         @click="ReadNotifications()"
        >{{$t('notifications.read_all')}}</b-button
      >
    </li>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BBadge,
  BMedia,
  BLink,
  BAvatar,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Ripple from "vue-ripple-directive";
import NotificationsactionsController from "@/Controllers/NotificationsActionsController";
import Activity from "@/Apis/Activities";
const ctr = new NotificationsactionsController();
export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BAvatar,
    VuePerfectScrollbar,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      systemNotifications: [],
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
      unreaded:0
    };
  },
  async created() {
      await this.get()
  },
  methods: {
    async ReadNotifications() {
      if (this.systemNotifications.length == 0) return;

      await ctr.ReadNotifications({
        type: "Student",
      });
      // this.systemNotifications = [];
      await this.get()
      
    },
    async ReadOneNotification(notification) {
      if(notification.read_at==null){
        await ctr.ReadOneNotification({
          type: "Student",
          id:notification.id
        });
        // this.systemNotifications = [];
        await this.get()
      }

      
    },
    async get(){
      this.unreaded=0;
      let res = await ctr.getNotifications();
      res.map((el)=>{
        el.read_at==null?this.unreaded++:true;
      })
      this.systemNotifications = res;

      console.log(this.unreaded);
    },
    async saveActivityType(notification){
      await this.ReadOneNotification(notification);
      if(notification.data.type=='activity'){
        localStorage.setItem('activity_type',JSON.parse(notification.data.name).activity_type);
        localStorage.setItem('course_id',JSON.parse(notification.data.name).course_id);
        this.$router.push("/page/studentActivities")
      }
      if(notification.data.type=='correct_activity'){
        localStorage.setItem('activity',JSON.stringify(JSON.parse(notification.data.name).activity));
        this.$router.push("/page/studentActivities")
      }
      if(notification.data.type=='activity_answer'){
        this.$router.push("/page/activityStudents/"+JSON.parse(notification.data.name).activity.id)
      }
    },
  },
};
</script>

<style>
</style>
